export const PERIODS = ['day', 'week', 'month'];
export const DEPOSIT_PERIODS = ['daily', 'weekly', 'monthly'];
export const DEPOSIT_UNLIMITED = 9223372036854776000;
export const UNLIMITED_STR = '9223372036854775807';
export const UNLIMITED = Number(UNLIMITED_STR);
export const DELAY = 350;
export const LOSS_UNLIMITED = 92233720368547760;
export const LOSS_UNLIMITED_STR = '92233720368547758.07';
export const RESPONSIBLE_GAMING_DEPOSIT_LIMITS = 'responsiblegamingdepositlimits';
export const PERIOD_CODES = {
    1: 'session',
    2: 'day',
    3: 'week',
    4: 'month'
};
